// Utila's own webhook-processing vocabulary. Kept under the vendor's name
// rather than an `Afriex` prefix, per the shared-types naming convention for a
// third party's vocabulary (see AdjustEvent, CustomerIoEvent).
//
// Hoisted from
// `packages/server/src/lib/clients/paymentProcessors/utila/types.ts` and
// `packages/admin/src/api/seeds.ts`, where admin's hand-mirrored string unions
// had already drifted: it was missing the `withdrawal_finalized` outcome
// status and the `withdrawal_not_terminal` / `withdrawal_hook_failed` skip
// reasons.
//
// `UtilaWebhookOutcome` is a discriminated union rather than an enum, but it
// lives here beside the two enums that discriminate it so the vendor contract
// stays in one place.
export var UtilaWebhookOutcomeStatus;
(function (UtilaWebhookOutcomeStatus) {
    UtilaWebhookOutcomeStatus["Credited"] = "credited";
    /**
     * An outgoing (off-ramp) transfer reached a terminal state and its
     * withdrawal hooks were run to finalize the Afriex transaction.
     */
    UtilaWebhookOutcomeStatus["WithdrawalFinalized"] = "withdrawal_finalized";
    UtilaWebhookOutcomeStatus["Skipped"] = "skipped";
})(UtilaWebhookOutcomeStatus || (UtilaWebhookOutcomeStatus = {}));
export var UtilaWebhookSkipReason;
(function (UtilaWebhookSkipReason) {
    UtilaWebhookSkipReason["UnknownEventType"] = "unknown_event_type";
    UtilaWebhookSkipReason["StateNotConfirmed"] = "state_not_confirmed";
    UtilaWebhookSkipReason["TransactionFetchFailed"] = "transaction_fetch_failed";
    UtilaWebhookSkipReason["TransactionNotEligible"] = "transaction_not_eligible";
    UtilaWebhookSkipReason["AssetFetchFailed"] = "asset_fetch_failed";
    UtilaWebhookSkipReason["UnsupportedAsset"] = "unsupported_asset";
    UtilaWebhookSkipReason["TransactionAlreadyExists"] = "already_exists";
    UtilaWebhookSkipReason["PaymentMethodNotFound"] = "payment_method_not_found";
    UtilaWebhookSkipReason["UserNotFound"] = "user_not_found";
    UtilaWebhookSkipReason["WithdrawalNotTerminal"] = "withdrawal_not_terminal";
    UtilaWebhookSkipReason["WithdrawalHookFailed"] = "withdrawal_hook_failed";
})(UtilaWebhookSkipReason || (UtilaWebhookSkipReason = {}));
//# sourceMappingURL=UtilaWebhook.js.map